'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// touchevents
var isTouchDeviceCachedValue = null;
var isTouch = exports.isTouch = function isTouch() {
  if (isTouchDeviceCachedValue !== null) return isTouchDeviceCachedValue;

  isTouchDeviceCachedValue = navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 || typeof document.body.ongesturestart === 'function';

  return isTouchDeviceCachedValue;
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/utils/polyfills.js
// module id = 637
// module chunks = 0